import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler, CAppSidebar } from '@coreui/react'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'
import { decryptString } from '../services/crypto'

import { logoNegative } from 'src/assets/brand/logo-negative'
import { sygnet } from 'src/assets/brand/sygnet'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import './AppSideBar.css'

// sidebar nav config
import navigation from '../_nav'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const [permissions] = useState(decryptString('permissoesAcesso'))
  const [idFunc] = useState(+decryptString('idFunc'))

  return (
    <CSidebar
      position="fixed"
      unfoldable
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="sidebar-brand-space d-none d-md-flex" to="/">
        {/* <CIcon className="sidebar-brand-full" icon={logoNegative} height={35} />
        <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} /> */}
        <img src="assets/images/logo.png" alt="Logo" className="sidebar-brand-full" height={35} />
        <img
          src="assets/images/logo_small.png"
          alt="Logo"
          className="sidebar-brand-narrow"
          height={35}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar className="style-simplebar">
          <AppSidebarNav items={navigation} permissions={permissions} idFunc={idFunc} />
        </SimpleBar>
      </CSidebarNav>
      {/* <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      /> */}
      <CSidebarToggler className="footer-sidebar" />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
